<div class="esf-submit-row" style="max-width: inherit">
  <div class="esf-submit-row__item" [style.opacity]="showSubmit ? 1 : 0">
    <button class="esf-button esf-button--standard esf-button--filled"
            type="submit"
            *ngIf="!showSpinner"
            [attr.form]="form ? form : null"
            (click)="submitButtonClicked()"
            [disabled]="!isFieldValid">{{ submitButtonText }}</button>

    <app-spinner [name]="spinnerName"></app-spinner>
  </div>

  <div class="esf-submit-row__item" [style.opacity]="showCancel ? 1 : 0">
    <button class="esf-button esf-button--standard esf-button--outlined"
            (click)="cancelButtonClicked()"
            type="button"
            *ngIf="useIcon">
      <svg class="esf-icon esf-button__icon" width="16" height="16">
        <use xlink:href="#esf-icon-minimal-left"></use>
      </svg>
      <span class="esf-button__icon-text">{{ cancelButtonText }}</span>
    </button>

    <button class="esf-button esf-button--standard esf-button--outlined"
            (click)="cancelButtonClicked()"
            type="button"
            *ngIf="!useIcon">{{ cancelButtonText }}
    </button>

    <ng-content></ng-content>

  </div>
</div>
